import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { values } from '../data/values'

const Values = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section id="values" className="section section-alt" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Our Values
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            The <span className="gradient-text">Principles</span> That Guide Us
          </h2>
          <p className={`section-subtext ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Our core values shape how we work, who we partner with, and the impact we create across New Zealand's talent landscape.
          </p>
        </div>

        <div className="values-grid">
          {values.map((value, index) => (
            <div 
              key={index} 
              className={`value-card card ${isVisible ? 'animate-fadeInUp' : ''}`}
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="card-header">
                <div className="value-icon">
                  <i className={value.icon}></i>
                </div>
                <div>
                  <h3>{value.title}</h3>
                  <span className="value-maori">{value.maori}</span>
                </div>
              </div>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Values
